<template>
  <div class="money-info" v-if="getPaymentSaldo !== false">
    <div class="money-header-info">Twoje środki</div>
    <div class="money-amount"><i class="mfind-icon-info"></i> {{ getPaymentSaldo | currency }}</div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('statistics')
export default {
  created () {
    this.$store.dispatch('statistics/getPaymentSaldo', 'get')
  },
  computed: {
    // mix the getters into the computed object
    ...mapGetters([
      'getPaymentSaldo'
    ])
  }
}
</script>

<style lang="scss">
@import 'src/stylesheets/variables';
.money-header-info {
  color: $secondary-color;
  font-size: 16px;
  line-height: 22px;
}
.money-info {
  text-align: right;
  margin-right: 20px;

  .money-amount {
    font-family: 'latoblack';
    font-size: 26px;
    line-height: 30px;

    i {
      display: inline-block;
      font-size: 18px;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// moneyInfo.vue?384a3d62